import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e9a9623"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Online_Audience" }
const _hoisted_2 = { class: "dudience_nav" }
const _hoisted_3 = { class: "nav_headLeft" }
const _hoisted_4 = { class: "nav_small_people" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "url_box"
}
const _hoisted_7 = ["src"]

import { Button, message, Table } from 'ant-design-vue';
import http from '@/api';
import { useConsoleStore } from '@/pinia/console';
import { useRoute } from 'vue-router';
import { nextTick, onMounted, reactive, ref, watch } from 'vue';
import { nullImg } from '@/assets';
import MList, { Column } from './MList.vue';
import { useDebounce } from '@/hooks/useDebounce';
import { Forbidden } from './ForbiddenWord.vue';
import { useThrottleFn } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlackList',
  setup(__props) {

const aButton = Button;
const aTable = Table;
const consoleStore = useConsoleStore();
const route = useRoute();
const studioId = route.params.studioId;
const violations = ref<Forbidden[]>([]);
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
});

/**
 * 获取列表
 * @param pageNum 请求的页面好吗
 */
const violationList = useThrottleFn((pageNum?: number) => {
  if (!pageNum && violations.value.length >= pageConfig.totalSize) return false;
  const { current, pageSize } = pageConfig;
  http.liveInformation
    .getViolationList({
      params: {
        page: pageNum ? pageNum : current + 1,
        page_num: pageSize,
        studio_id: studioId,
        status: 2,
      },
    })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      if (pageNum) {
        violations.value = res.data.data.data;
      } else {
        violations.value = violations.value.concat(res.data.data.data);
      }
    });
}, 500);
violationList(1);

const pullBlack = (item: any) => {
  let pullblack = {
    studio_id: route.params.studioId,
    status: 0,
    avatar: item.avatar,
    monitor_id: consoleStore.consoleInfo.monitorId,
    nickname: item.nickname,
    uid: item.uid,
  };
  http.liveInformation
    .getPullBlack(pullblack)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
      // 处理筛选的数据
      violations.value = violations.value.filter((cur) => cur.uid !== item.uid);
      pageConfig.current = violations.value.length / pageConfig.pageSize;
      pageConfig.totalSize--;
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
const columns: Column[] = [
  {
    title: '头像',
    dataIndex: 'avatar_url',
    align: 'center',
    slots: { customRender: 'url' },
  },
  {
    title: '昵称',
    dataIndex: 'nickname',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '拉黑时间',
    dataIndex: 'created_at',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '设备',
    width: '28%',
    align: 'center',
    slots: { customRender: 'equipment' },
  },
];
const mlistRef = ref<HTMLDivElement>();
const mlistHight = ref(0);

watch(violations, (newVal) => {
  if (mlistHight.value) return;
  if (newVal.length > 0) {
    nextTick(() => {
      mlistRef.value && (mlistHight.value = mlistRef.value.offsetHeight);
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_svg_icon, {
            "icon-class": "live_chat_people",
            class: "nav_img"
          }),
          _createTextVNode(_toDisplayString(pageConfig.totalSize), 1)
        ])
      ])
    ]),
    (violations.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "mlistRef",
          ref: mlistRef,
          class: "dudience_content"
        }, [
          _withDirectives(_createVNode(MList, {
            columns: columns,
            "data-source": violations.value,
            "data-key": "id",
            height: mlistHight.value,
            "infinite-scroll": _unref(violationList)
          }, {
            url: _withCtx(({ record }) => [
              _createElementVNode("img", {
                src: record.avatar_url,
                alt: "",
                style: {"width":"30px","height":"30px"}
              }, null, 8, _hoisted_5)
            ]),
            equipment: _withCtx(({ record }) => [
              _createVNode(_unref(aButton), {
                class: "btn_select",
                onClick: ($event: any) => (pullBlack(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("解除")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["data-source", "height", "infinite-scroll"]), [
            [_vShow, mlistHight.value]
          ])
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("img", { src: _unref(nullImg) }, null, 8, _hoisted_7)
        ]))
  ]))
}
}

})